import { APP_API_V1_BASE } from "../../config/api";
// // import { useEffect, useState, useRef } from "react";
// // import {
// //     Box,
// //     Typography,
// //     Button,
// //     Paper,
// //     Chip,
// //     Dialog,
// //     DialogTitle,
// //     DialogContent,
// //     DialogActions,
// //     TextField,
// //     MenuItem,
// //     Switch,
// //     Snackbar,
// //     Alert as MuiAlert,
// //     FormControlLabel,
// //     IconButton,
// //     Stack,
// //     Tabs,
// //     Tab,
// //     Badge,
// // } from "@mui/material";
// // import { DataGrid } from "@mui/x-data-grid";
// // import axios from "axios";
// // import { useAuth } from "../../auth/useAuth";
// // import { can } from "../../auth/can";
// // import { Delete, Edit, Sensors } from "@mui/icons-material";

// // const API_BASE = `${APP_API_V1_BASE}`;

// // export default function DeviceAlarms({ device }) {
// //     const { activeOrg, permissions } = useAuth();
// //     const token = localStorage.getItem("authToken");

// //     const [alerts, setAlerts] = useState([]);
// //     const [rules, setRules] = useState([]);
// //     const [openRuleDialog, setOpenRuleDialog] = useState(false);
// //     const [statusFilter, setStatusFilter] = useState("active");
// //     const [severityFilter, setSeverityFilter] = useState("all");
// //     const [autoRefresh, setAutoRefresh] = useState(true);
// //     const [selectedRows, setSelectedRows] = useState([]);
// //     const [selectedRuleRows, setSelectedRuleRows] = useState([]);
// //     const [subTab, setSubTab] = useState(0);
// //     const [notificationSettings, setNotificationSettings] = useState({
// //     email_enabled: false,
// //     sms_enabled: false,
// //     webhook_enabled: false,
// //     });

// //     const [toast, setToast] = useState({
// //         open: false,
// //         message: "",
// //         severity: "warning",
// //     });

// //     useEffect(() => {
// //         if (!autoRefresh) return;

// //         const interval = setInterval(() => {
// //             loadData();
// //         }, 10000);

// //         return () => clearInterval(interval);
// //     }, [autoRefresh]);

// //     const filteredAlerts = alerts.filter((a) => {
// //         if (statusFilter !== "all" && a.status !== statusFilter)
// //             return false;

// //         if (severityFilter !== "all" && a.severity !== severityFilter)
// //             return false;

// //         return true;
// //     });

// //     const previousAlertIds = useRef(new Set());

// //     const [newRule, setNewRule] = useState({
// //         metric_key: "",
// //         operator: ">",
// //         threshold: "",
// //         severity: "warning",
// //     });

// //     const headers = {
// //         Authorization: `Bearer ${token}`,
// //         ...(activeOrg?.id && { "X-Org-ID": activeOrg.id }),
// //     };

// //     /* --------------------------------------------------
// //        Load alerts + rules
// //     -------------------------------------------------- */
// //     const loadData = async () => {
// //         try {
// //             const [alertsRes, rulesRes] = await Promise.all([
// //                 axios.get(`${API_BASE}/devices/${device.id}/alerts`, { headers }),
// //                 axios.get(`${API_BASE}/devices/${device.id}/alerts/rules`, { headers }),
// //             ]);

// //             const fetchedAlerts = alertsRes.data;

// //             detectNewAlerts(fetchedAlerts);

// //             setAlerts(fetchedAlerts);
// //             setRules(rulesRes.data);
// //         } catch (err) {
// //             console.error("Failed to load alarms", err);
// //         }
// //     };

// //     /* --------------------------------------------------
// //        Detect New Alerts (TOAST LOGIC)
// //     -------------------------------------------------- */
// //     const detectNewAlerts = (fetchedAlerts) => {
// //         const currentActive = fetchedAlerts.filter(
// //             (a) => a.status === "active"
// //         );

// //         currentActive.forEach((alert) => {
// //             if (!previousAlertIds.current.has(alert.id)) {
// //                 setToast({
// //                     open: true,
// //                     message: `${alert.metric_key} ${alert.operator} ${alert.threshold} (Value: ${alert.value})`,
// //                     severity: mapSeverity(alert.severity),
// //                 });
// //             }
// //         });

// //         previousAlertIds.current = new Set(
// //             currentActive.map((a) => a.id)
// //         );
// //     };

// //     const mapSeverity = (severity) => {
// //         const map = {
// //             critical: "error",
// //             high: "warning",
// //             warning: "info",
// //             info: "success",
// //         };
// //         return map[severity] || "warning";
// //     };

// //     useEffect(() => {
// //         if (!device?.id) return;

// //         loadData();

// //         const interval = setInterval(() => {
// //             loadData();
// //         }, 10000);

// //         return () => clearInterval(interval);
// //     }, [device]);

// //     /* --------------------------------------------------
// //        Rule Actions
// //     -------------------------------------------------- */
// //     const createRule = async () => {
// //         try {
// //             await axios.post(
// //                 `${API_BASE}/devices/${device.id}/alerts/rules`,
// //                 newRule,
// //                 { headers }
// //             );

// //             setOpenRuleDialog(false);
// //             setNewRule({
// //                 metric_key: "",
// //                 operator: ">",
// //                 threshold: "",
// //                 severity: "warning",
// //             });

// //             loadData();
// //         } catch (err) {
// //             console.error("Rule creation failed", err);
// //         }
// //     };

// //     const toggleRule = async (id, currentState) => {
// //         try {
// //             await axios.patch(
// //                 `${API_BASE}/devices/${device.id}/alerts/rules/${id}`,
// //                 { enabled: !currentState },
// //                 { headers }
// //             );
// //             loadData();
// //         } catch (err) {
// //             console.error("Toggle failed", err);
// //         }
// //     };

// //     const bulkToggleRules = async () => {
// //         try {
// //             await axios.post(
// //                 `${API_BASE}/alerts/rules/bulk-toggle`,
// //                 { rule_ids: selectedRuleRows },
// //                 { headers }
// //             );

// //             setSelectedRuleRows([]);
// //             loadData();
// //         } catch (err) {
// //             console.error("Bulk toggle failed", err);
// //         }
// //     };

// //     const editRule = (rule) => {
// //         setNewRule(rule);
// //         setOpenRuleDialog(true);
// //     };

// //     const deleteRule = async (id) => {
// //         try {
// //             await axios.delete(
// //                 `${API_BASE}/devices/${device.id}/alerts/rules/${id}`,
// //                 { headers }
// //             );
// //             loadData();
// //         } catch (err) {
// //             console.error("Delete failed", err);
// //         }
// //     };

// //     const acknowledgeAlert = async (alertId) => {
// //         try {
// //             await axios.patch(
// //                 `${API_BASE}/alerts/${alertId}/acknowledge`,
// //                 {},
// //                 { headers }
// //             );
// //             loadData();
// //         } catch (err) {
// //             console.error("Failed to acknowledge alert", err);
// //         }
// //     };

// //     /* --------------------------------------------------
// //        Columns
// //     -------------------------------------------------- */

// //     const alertColumns = [
// //         {
// //             field: "severity",
// //             headerName: "Severity",
// //             width: 120,
// //             renderCell: (params) => {
// //                 const colorMap = {
// //                     critical: "error",
// //                     high: "warning",
// //                     warning: "info",
// //                     info: "default",
// //                 };
// //                 return (
// //                     <Chip
// //                         label={params.value?.toUpperCase()}
// //                         color={colorMap[params.value] || "default"}
// //                         size="small"
// //                     />
// //                 );
// //             },
// //         },
// //         {
// //             field: "metric_key",
// //             headerName: "Metric",
// //             flex: 1,
// //         },
// //         {
// //             field: "value",
// //             headerName: "Value",
// //             width: 120,
// //         },
// //         {
// //             field: "duration",
// //             headerName: "Duration",
// //             width: 140,
// //             renderCell: (params) => {
// //                 const start = new Date(params.row.triggered_at);
// //                 const end = params.row.cleared_at
// //                     ? new Date(params.row.cleared_at)
// //                     : new Date();

// //                 const diffMs = end - start;
// //                 const minutes = Math.floor(diffMs / 60000);

// //                 return `${minutes} min`;
// //             },
// //         },
// //         {
// //             field: "status",
// //             headerName: "Status",
// //             width: 130,
// //             renderCell: (params) => (
// //                 <Chip
// //                     label={params.value.toUpperCase()}
// //                     color={
// //                         params.value === "active"
// //                             ? "error"
// //                             : params.value === "acknowledged"
// //                                 ? "warning"
// //                                 : "success"
// //                     }
// //                     size="small"
// //                 />
// //             ),
// //         },
// //         {
// //             field: "acknowledged_by",
// //             headerName: "Acknowledged By",
// //             width: 180,
// //         },
// //         {
// //             field: "triggered_at",
// //             headerName: "Triggered At",
// //             flex: 1,
// //             renderCell: (params) =>
// //                 new Date(params.value).toLocaleString(),
// //         },
// //         {
// //             field: "actions",
// //             headerName: "Actions",
// //             width: 150,
// //             renderCell: (params) => {
// //                 if (params.row.status !== "active")
// //                     return null;

// //                 return (
// //                     <Button
// //                         size="small"
// //                         onClick={() => acknowledgeAlert(params.row.id)}
// //                     >
// //                         Acknowledge
// //                     </Button>
// //                 );
// //             },
// //         },
// //     ];

// //     const bulkAcknowledge = async () => {
// //         try {
// //             await axios.post(
// //                 `${API_BASE}/alerts/bulk-acknowledge`,
// //                 { alert_ids: selectedRows },
// //                 { headers }
// //             );

// //             setSelectedRows([]);
// //             loadData();
// //         } catch (err) {
// //             console.error("Bulk acknowledge failed", err);
// //         }
// //     };

// //     const ruleColumns = [
// //         {
// //             field: "metric_key",
// //             headerName: "Metric",
// //             flex: 1,
// //             renderCell: (params) => (
// //                 <Box display="flex" alignItems="center" gap={1}>
// //                     <Sensors sx={{ fontSize: 18, color: "#607D8B" }} />
// //                     <Typography fontWeight={600}>
// //                         {params.value}
// //                     </Typography>
// //                 </Box>
// //             ),
// //         },
// //         {
// //             field: "operator",
// //             headerName: "Condition",
// //             width: 120,
// //             renderCell: (params) => (
// //                 <Chip
// //                     label={params.value}
// //                     size="small"
// //                     sx={{
// //                         fontWeight: 600,
// //                         backgroundColor: "#ECEFF1",
// //                     }}
// //                 />
// //             ),
// //         },
// //         {
// //             field: "threshold",
// //             headerName: "Threshold",
// //             width: 160,
// //             renderCell: (params) => {

// //                 const field = device?.schema?.find(
// //                     (f) => f.key === params.row.metric_key
// //                 );

// //                 const unit =
// //                     field?.unit === "Custom"
// //                         ? field?.customUnit || ""
// //                         : field?.unit || "";
// //                 return (
// //                     <Typography fontWeight={600}>
// //                         {params.value} {unit}
// //                     </Typography>
// //                 );
// //             },
// //         },
// //         {
// //             field: "severity",
// //             headerName: "Severity",
// //             width: 140,
// //             renderCell: (params) => {
// //                 const map = {
// //                     critical: { color: "#D32F2F", bg: "#FDECEA" },
// //                     high: { color: "#F57C00", bg: "#FFF4E5" },
// //                     warning: { color: "#ED6C02", bg: "#FFF3E0" },
// //                     info: { color: "#0288D1", bg: "#E3F2FD" },
// //                 };

// //                 const style = map[params.value] || {};

// //                 return (
// //                     <Chip
// //                         label={params.value?.toUpperCase()}
// //                         size="small"
// //                         sx={{
// //                             fontWeight: 600,
// //                             color: style.color,
// //                             backgroundColor: style.bg,
// //                         }}
// //                     />
// //                 );
// //             },
// //         },
// //         {
// //             field: "enabled",
// //             headerName: "Status",
// //             width: 120,
// //             renderCell: (params) => (
// //                 <Switch
// //                     checked={params.value}
// //                     onChange={() =>
// //                         toggleRule(params.row.id, params.value)
// //                     }
// //                     size="small"
// //                 />
// //             ),
// //         },
// //         {
// //             field: "actions",
// //             headerName: "",
// //             width: 120,
// //             sortable: false,
// //             renderCell: (params) => (
// //                 <Box display="flex" gap={1}>
// //                     <IconButton
// //                         size="small"
// //                         onClick={() => editRule(params.row)}
// //                     >
// //                         <Edit fontSize="small" />
// //                     </IconButton>

// //                     <IconButton
// //                         size="small"
// //                         color="error"
// //                         onClick={() => deleteRule(params.row.id)}
// //                     >
// //                         <Delete fontSize="small" />
// //                     </IconButton>
// //                 </Box>
// //             ),
// //         },
// //     ];

// // return (
// //   <Box>

// //     {/* ================== SUB TABS ================== */}
// //     <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
// //       <Tabs
// //         value={subTab}
// //         onChange={(e, newValue) => setSubTab(newValue)}
// //         variant="scrollable"
// //         scrollButtons="auto"
// //       >
// //         <Tab
// //           label={
// //             <Badge
// //               color="error"
// //               badgeContent={alerts.filter(a => a.status === "active").length}
// //             >
// //               Events
// //             </Badge>
// //           }
// //         />
// //         <Tab label="Rules" />
// //         <Tab label="Notifications" />
// //         <Tab label="Analytics" />
// //         <Tab label="History" />
// //       </Tabs>
// //     </Box>

// //     {/* ================== EVENTS TAB ================== */}
// // {subTab === 0 && (
// //   <Box>

// //     {/* ================= FILTER ROW ================= */}
// //     <Box mb={3} display="flex" gap={2} alignItems="center">
// //       <TextField
// //         select
// //         size="small"
// //         label="Status"
// //         value={statusFilter}
// //         onChange={(e) => setStatusFilter(e.target.value)}
// //       >
// //         <MenuItem value="active">Active</MenuItem>
// //         <MenuItem value="acknowledged">Acknowledged</MenuItem>
// //         <MenuItem value="cleared">Cleared</MenuItem>
// //         <MenuItem value="all">All</MenuItem>
// //       </TextField>

// //       <FormControlLabel
// //         control={
// //           <Switch
// //             checked={autoRefresh}
// //             onChange={(e) => setAutoRefresh(e.target.checked)}
// //           />
// //         }
// //         label="Auto Refresh"
// //       />
// //     </Box>

// //     {/* ================= GROUPED ALERT VIEW ================= */}
// //     {["critical", "high", "warning", "info"].map((level) => {
// //       const grouped = filteredAlerts.filter(
// //         (a) => a.severity === level
// //       );

// //       if (grouped.length === 0) return null;

// //       const colorMap = {
// //         critical: "#D32F2F",
// //         high: "#F57C00",
// //         warning: "#ED6C02",
// //         info: "#0288D1",
// //       };

// //       return (
// //         <Box key={level} mb={4}>
// //           <Typography
// //             variant="subtitle1"
// //             fontWeight={700}
// //             mb={2}
// //             sx={{ color: colorMap[level] }}
// //           >
// //             {level.toUpperCase()} ({grouped.length})
// //           </Typography>

// //           <Box display="flex" flexDirection="column" gap={2}>
// //             {grouped.map((alert) => {
// //               const start = new Date(alert.triggered_at);
// //               const diffMs = new Date() - start;
// //               const minutes = Math.floor(diffMs / 60000);

// //               return (
// //                 <Paper
// //                   key={alert.id}
// //                   sx={{
// //                     p: 3,
// //                     borderLeft: `6px solid ${colorMap[level]}`,
// //                     boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
// //                   }}
// //                 >
// //                   <Box display="flex" justifyContent="space-between">

// //                     {/* LEFT SIDE */}
// //                     <Box>
// //                       <Typography fontWeight={700}>
// //                         {alert.metric_key}
// //                       </Typography>

// //                       <Typography variant="body2" color="text.secondary">
// //                         Value: <strong>{alert.value}</strong>
// //                       </Typography>

// //                       <Typography variant="caption" color="text.secondary">
// //                         Triggered {minutes} min ago
// //                       </Typography>
// //                     </Box>

// //                     {/* RIGHT SIDE */}
// //                     <Box textAlign="right">
// //                       <Chip
// //                         label={alert.status.toUpperCase()}
// //                         size="small"
// //                         sx={{
// //                           backgroundColor: colorMap[level],
// //                           color: "#fff",
// //                           fontWeight: 600,
// //                           mb: 1
// //                         }}
// //                       />

// //                       {alert.status === "active" && (
// //                         <Button
// //                           size="small"
// //                           variant="outlined"
// //                           onClick={() => acknowledgeAlert(alert.id)}
// //                         >
// //                           Acknowledge
// //                         </Button>
// //                       )}
// //                     </Box>

// //                   </Box>
// //                 </Paper>
// //               );
// //             })}
// //           </Box>
// //         </Box>
// //       );
// //     })}

// //     {filteredAlerts.length === 0 && (
// //       <Paper sx={{ p: 4, textAlign: "center" }}>
// //         <Typography color="text.secondary">
// //           No alerts found
// //         </Typography>
// //       </Paper>
// //     )}

// //   </Box>
// // )}

// //     {/* ================== RULES TAB ================== */}
// //     {subTab === 1 && (
// //       <Paper sx={{ p: 3 }}>
// //         <Box
// //           display="flex"
// //           justifyContent="space-between"
// //           mb={2}
// //         >
// //           <Typography variant="h6">
// //             Alert Rules
// //           </Typography>

// //           <Button
// //             variant="contained"
// //             onClick={() => setOpenRuleDialog(true)}
// //           >
// //             + Create Rule
// //           </Button>
// //         </Box>

// //         <DataGrid
// //           rows={rules}
// //           columns={ruleColumns}
// //           autoHeight
// //           checkboxSelection
// //           getRowId={(r) => r.id}
// //           disableColumnMenu
// //         />
// //       </Paper>
// //     )}

// //     {/* ================== NOTIFICATIONS TAB ================== */}
// //     {subTab === 2 && (
// //       <Paper sx={{ p: 3 }}>
// //         <Typography variant="h6" fontWeight={600} mb={3}>
// //           Notification Channels
// //         </Typography>

// //         <Stack spacing={3}>
// //           <FormControlLabel
// //             control={
// //               <Switch
// //                 checked={notificationSettings.email_enabled}
// //                 onChange={async (e) => {
// //                   await axios.patch(
// //                     `${API_BASE}/organizations/${activeOrg.id}/notification-settings`,
// //                     { email_enabled: e.target.checked },
// //                     { headers }
// //                   );
// //                   loadData();
// //                 }}
// //               />
// //             }
// //             label="Email Notifications"
// //           />

// //           <FormControlLabel
// //             control={
// //               <Switch
// //                 checked={notificationSettings.sms_enabled}
// //                 onChange={async (e) => {
// //                   await axios.patch(
// //                     `${API_BASE}/organizations/${activeOrg.id}/notification-settings`,
// //                     { sms_enabled: e.target.checked },
// //                     { headers }
// //                   );
// //                   loadData();
// //                 }}
// //               />
// //             }
// //             label="SMS Notifications"
// //           />

// //           <FormControlLabel
// //             control={
// //               <Switch
// //                 checked={notificationSettings.webhook_enabled}
// //                 onChange={async (e) => {
// //                   await axios.patch(
// //                     `${API_BASE}/organizations/${activeOrg.id}/notification-settings`,
// //                     { webhook_enabled: e.target.checked },
// //                     { headers }
// //                   );
// //                   loadData();
// //                 }}
// //               />
// //             }
// //             label="Webhook Notifications"
// //           />
// //         </Stack>
// //       </Paper>
// //     )}

// //     {/* ================== ANALYTICS TAB ================== */}
// //     {subTab === 3 && (
// //       <Paper sx={{ p: 3 }}>
// //         <Typography variant="h6" mb={2}>
// //           Alert Analytics
// //         </Typography>

// //         <Box display="flex" gap={4}>
// //           <Paper sx={{ p: 2, flex: 1 }}>
// //             <Typography variant="subtitle2">
// //               Total Alerts
// //             </Typography>
// //             <Typography variant="h4">
// //               {alerts.length}
// //             </Typography>
// //           </Paper>

// //           <Paper sx={{ p: 2, flex: 1 }}>
// //             <Typography variant="subtitle2">
// //               Active Alerts
// //             </Typography>
// //             <Typography variant="h4" color="error">
// //               {alerts.filter(a => a.status === "active").length}
// //             </Typography>
// //           </Paper>

// //           <Paper sx={{ p: 2, flex: 1 }}>
// //             <Typography variant="subtitle2">
// //               Acknowledged
// //             </Typography>
// //             <Typography variant="h4" color="warning.main">
// //               {alerts.filter(a => a.status === "acknowledged").length}
// //             </Typography>
// //           </Paper>

// //           <Paper sx={{ p: 2, flex: 1 }}>
// //             <Typography variant="subtitle2">
// //               Cleared
// //             </Typography>
// //             <Typography variant="h4" color="success.main">
// //               {alerts.filter(a => a.status === "cleared").length}
// //             </Typography>
// //           </Paper>
// //         </Box>
// //       </Paper>
// //     )}

// //     {/* ================== HISTORY TAB ================== */}
// //     {subTab === 4 && (
// //       <Paper sx={{ p: 3 }}>
// //         <Typography variant="h6" mb={2}>
// //           Alert History
// //         </Typography>

// //         <DataGrid
// //           rows={alerts}
// //           columns={[
// //             ...alertColumns,
// //             {
// //               field: "cleared_at",
// //               headerName: "Cleared At",
// //               flex: 1,
// //               renderCell: (params) =>
// //                 params.value
// //                   ? new Date(params.value).toLocaleString()
// //                   : "-",
// //             },
// //           ]}
// //           autoHeight
// //           getRowId={(r) => r.id}
// //           disableColumnMenu
// //         />
// //       </Paper>
// //     )}

// //   </Box>
// // );
// // }

// import { useEffect, useState, useRef } from "react";
// import { Box, Tabs, Tab, Badge } from "@mui/material";
// import axios from "axios";
// import { useAuth } from "../../auth/useAuth";
// import EventsTab from "./DeviceTab/EventsTab";
// import RulesTab from "./DeviceTab/RulesTab";
// import AnalyticsTab from "./DeviceTab/AnalyticsTab";
// import HistoryTab from "./DeviceTab/HistoryTab";
// import NotificationsTab from "./DeviceTab/NotificationsTab";

// const API_BASE = `${APP_API_V1_BASE}`;

// export default function DeviceAlarms({ device }) {
//   const { activeOrg } = useAuth();
//   const token = localStorage.getItem("authToken");

//   const [alerts, setAlerts] = useState([]);
//   const [rules, setRules] = useState([]);
//   const [subTab, setSubTab] = useState(0);
//   const [autoRefresh, setAutoRefresh] = useState(true);

//   const previousAlertIds = useRef(new Set());

//   const headers = {
//     Authorization: `Bearer ${token}`,
//     ...(activeOrg?.id && { "X-Org-ID": activeOrg.id }),
//   };

//   const mapSeverity = (severity) => {
//     const map = {
//       critical: "error",
//       high: "warning",
//       warning: "info",
//       info: "success",
//     };
//     return map[severity] || "warning";
//   };

//   const detectNewAlerts = (fetchedAlerts) => {
//     const currentActive = fetchedAlerts.filter(
//       (a) => a.status === "active"
//     );

//     currentActive.forEach((alert) => {
//       if (!previousAlertIds.current.has(alert.id)) {
//         console.log("New Alert:", alert.metric_key);
//       }
//     });

//     previousAlertIds.current = new Set(
//       currentActive.map((a) => a.id)
//     );
//   };

//   const loadData = async () => {
//     if (!device?.id) return;

//     try {
//       const [alertsRes, rulesRes] = await Promise.all([
//         axios.get(`${API_BASE}/devices/${device.id}/alerts`, { headers }),
//         axios.get(`${API_BASE}/devices/${device.id}/alerts/rules`, { headers }),
//       ]);

//       detectNewAlerts(alertsRes.data);

//       setAlerts(alertsRes.data);
//       setRules(rulesRes.data);
//     } catch (err) {
//       console.error("Failed to load alarms", err);
//     }
//   };

// useEffect(() => {
//   if (!device?.id) return;
//   loadData();
//   if (!autoRefresh) return;
//   const interval = setInterval(loadData, 10000);
//   return () => clearInterval(interval);
// }, [device, autoRefresh]);

//   return (
//     <Box>
//       <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
//         <Tabs value={subTab} onChange={(e, v) => setSubTab(v)}>
//           <Tab
//             label={
//               <Badge
//                 color="error"
//                 badgeContent={
//                   alerts.filter(a => a.status === "active").length
//                 }
//               >
//                 Events
//               </Badge>
//             }
//           />
//           <Tab label="Rules" />
//           <Tab label="Notifications" />
//           <Tab label="Analytics" />
//           <Tab label="History" />
//         </Tabs>
//       </Box>

//       {subTab === 0 && (
//         <EventsTab
//           alerts={alerts}
//           device={device}
//           autoRefresh={autoRefresh}
//           setAutoRefresh={setAutoRefresh}
//           loadData={loadData}
//           headers={headers}
//         />
//       )}

//       {subTab === 1 && (
//         <RulesTab
//           rules={rules}
//           device={device}
//           headers={headers}
//           loadData={loadData}
//         />
//       )}

//       {subTab === 2 && (
//         <NotificationsTab
//           activeOrg={activeOrg}
//           headers={headers}
//         />
//       )}

//       {subTab === 3 && (
//         <AnalyticsTab alerts={alerts} />
//       )}

//       {subTab === 4 && (
//         <HistoryTab alerts={alerts} />
//       )}
//     </Box>
//   );
// }

import { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Box, Tabs, Tab, Badge, Snackbar, Alert } from "@mui/material";
import axios from "axios";
import { useAuth } from "../../auth/useAuth";
import EventsTab from "./DeviceTab/EventsTab";
import RulesTab from "./DeviceTab/RulesTab";
import AnalyticsTab from "./DeviceTab/AnalyticsTab";
import HistoryTab from "./DeviceTab/HistoryTab";
import NotificationsTab from "./DeviceTab/NotificationsTab";

const API_BASE = `${APP_API_V1_BASE}`;

export default function DeviceAlarms({ device }) {
  const { activeOrg } = useAuth();

  // ✅ FIX: Read token from auth hook or localStorage — re-read on each render
  // so a refreshed token is always picked up
  const token = localStorage.getItem("authToken");

  const [alerts, setAlerts] = useState([]);
  const [rules, setRules] = useState([]);
  const [subTab, setSubTab] = useState(0);
  const [autoRefresh, setAutoRefresh] = useState(true);

  const previousAlertIds = useRef(new Set());

  const notifiedAlertIds = useRef(new Set());

  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  // ✅ FIX: Memoize headers so loadData/useCallback deps are stable
  const headers = useMemo(
    () => ({
      Authorization: `Bearer ${token}`,
      ...(activeOrg?.id && { "X-Org-ID": activeOrg.id }),
    }),
    [token, activeOrg?.id],
  );

  const detectNewAlerts = useCallback((fetchedAlerts) => {
    const currentActive = fetchedAlerts.filter((a) => a.status === "active");

    currentActive.forEach((alert) => {
      if (!previousAlertIds.current.has(alert.id) && 
          !notifiedAlertIds.current.has(alert.id)) 
          {
        //console.log("New Alert:", alert.metric_key);
        // TODO: wire up toast/notification here
        const deviceName =device?.name || device?.device_name ||"Device";
        const metricName = alert.metric_key || "Unknown Metric";
        const severity = alert.severity ? alert.severity.toUpperCase() : "UNKNOWN";
        
        setNotification({
          open: true,
          message: `New alert on ${deviceName}: ${metricName} is ${severity}`,
          severity: "warning"
        });
        notifiedAlertIds.current.add(alert.id);
      }
    });

    previousAlertIds.current = new Set(currentActive.map((a) => a.id));
  }, [device]);

  // ✅ FIX: Stable loadData reference — won't cause stale interval captures
  const loadData = useCallback(async () => {
    if (!device?.id) return;

    try {
      const [alertsRes, rulesRes] = await Promise.all([
        axios.get(`${API_BASE}/devices/${device.id}/alerts`, { headers }),
        axios.get(`${API_BASE}/devices/${device.id}/alerts/rules`, { headers }),
      ]);

      detectNewAlerts(alertsRes.data);
      setAlerts(alertsRes.data);
      setRules(rulesRes.data);
    } catch (err) {
      console.error("Failed to load alarms", err);
      setNotification({
        open: true,
        message: "Unable to load device alerts. Please try again",
        severity: "error", 
      });
    }
  }, [device?.id, headers, detectNewAlerts]);

  // ✅ FIX: Single effect handles both initial load and polling
  // Eliminates the double-interval bug from two separate useEffects
  useEffect(() => {
    if (!device?.id) return;

    loadData();

    if (!autoRefresh) return;

    const interval = setInterval(loadData, 10000);
    return () => clearInterval(interval);
  }, [device?.id, autoRefresh, loadData]);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs
          value={subTab}
          onChange={(e, v) => setSubTab(v)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            label={
              <Badge
                color="error"
                badgeContent={
                  alerts.filter((a) => a.status === "active").length
                }
              >
                Events
              </Badge>
            }
          />
          <Tab label="Rules" />
          <Tab label="Notifications" />
          <Tab label="Analytics" />
          <Tab label="History" />
        </Tabs>
      </Box>

      {subTab === 0 && (
        <EventsTab
          alerts={alerts}
          device={device}
          autoRefresh={autoRefresh}
          setAutoRefresh={setAutoRefresh}
          loadData={loadData}
          headers={headers}
        />
      )}

      {subTab === 1 && (
        <RulesTab
          rules={rules}
          device={device}
          headers={headers}
          loadData={loadData}
        />
      )}

      {subTab === 2 && (
        <NotificationsTab activeOrg={activeOrg} headers={headers} />
      )}

      {subTab === 3 && <AnalyticsTab alerts={alerts} />}

      {subTab === 4 && <HistoryTab alerts={alerts} />}
      <Snackbar
      open={notification.open}
      autoHideDuration={6000}
      onClose={() =>
        setNotification ((prev) => ({
          ...prev,
          open: false,
        }))
      }
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Alert 
      onClose={() =>setNotification((prev) => ({
        ...prev,
        open: false,
      }))
    }
    severity={notification.severity}
    variant="filled"
    sx={{width: "100%"}}
    >
      {notification.message}
    </Alert>
    </Snackbar>
    </Box>
  );
}
